const PAXSGROUP_UPDATED = (state, PaxsGroup) => {
  state.PaxsGroup = PaxsGroup
}

const DATAPAXLEADER_UPDATED = (state, DataPaxLeader) => {
  state.DataPaxLeader = DataPaxLeader
}

const CHECK_PASSENGER_SERVICE = (state, PassengerService) => {
  state.PassengerService = PassengerService
}

export default {
  PAXSGROUP_UPDATED,
  DATAPAXLEADER_UPDATED,
  CHECK_PASSENGER_SERVICE
}
